import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App, { preloadRoute } from "@/App";

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

const container = document.getElementById("root");
// Hydrate de geprerenderde HTML (SSG): eerste paint komt direct uit de HTML (snelle
// LCP), React koppelt daarna events zonder de DOM te vervangen. Alle markup is
// hydratie-safe (sessie-refs zoals lead_ref worden pas bij klik toegevoegd).
// onRecoverableError logt eventuele toekomstige mismatches met component-stack.
const onRecoverableError = (error, errorInfo) => {
  console.error("HYDRATION:", error?.message || error, errorInfo?.componentStack || "");
};
const boot = () => {
  if (container.hasChildNodes()) {
    hydrateRoot(container, app, { onRecoverableError });
  } else {
    createRoot(container).render(app);
  }
};
// Eerst de chunk van de huidige route laden, dan pas hydrateren: zo ziet React bij
// hydratie meteen de echte pagina i.p.v. de Suspense-fallback (geen mismatch).
preloadRoute(window.location.pathname).then(boot, boot);
